import { connect } from 'react-redux';
import { SearchWidgetInitializer } from './SearchWidgetInitializer';

import {
  changeSearchParamsAction,
  refreshEmptySearchParamsAction,
} from '../../routes/SearchPage/actions/search';
import { getSearchParams } from '../../store/enqueue/selectors';
import { getAppName } from '../../store/view/selectors';

const mapStateToProps = (state) => ({
  searchParams: getSearchParams(state),
  appName: getAppName(state),
});

const mapDispatchToProps = (dispatch) => ({
  onChangeSearchParams: (url) => {
    dispatch(changeSearchParamsAction(url));
    dispatch(refreshEmptySearchParamsAction());
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SearchWidgetInitializer);
